export default class ShopEnd extends Phaser.Group {
  constructor(game) {
    super(game);

    this.wall = this.game.make.sprite(0, 0, 'shop_end');
    this.addChild(this.wall);

    this.patty = this.game.make.spine(790, 240, 'patty');
    this.patty.anchor.set(0.5, 1);
    this.patty.setAnimationByName(0, 'IdleBlink', true);
    this.addChild(this.patty);

    this.desk = this.game.make.image(840, 300, 'shop_end_desk');
    this.desk.anchor.set(0.5, 1);
    this.addChild(this.desk);
  }

  playPattyEnd() {
    this.patty.setAnimationByName(0, 'Dance', true);
  }

  destroy() {
    this.wall = null;
    this.patty = null;
    this.desk = null;

    super.destroy();
  }
}
